import { render, staticRenderFns } from "./Confirm_promotion_broadband.vue?vue&type=template&id=53b43e78&"
import script from "./Confirm_promotion_broadband.vue?vue&type=script&lang=js&"
export * from "./Confirm_promotion_broadband.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports